export default {
  accepted: 'Aceito',
  accessRequestDate: 'Data da solicitação de acesso',
  confirmUserWillBeSystemAdmin: 'O usuário será administrador do sistema. Continuar?',
  copyInvitationLink: 'Copiar link de convite para a área de transferência',
  copyInvitationLinkConfirmMessage: `Se o usuário convidado não tiver recebido emails no endereço {{email}},
você pode copiar o link do convite para a área de transferência e compartilhá-lo por outros meios.

Copiar o link de convite para a área de transferência?`,
  copyPasswordResetLink: 'Copiar link de redefinição de senha para a área de transferência?',
  copyPasswordResetLinkConfirmMessage: `Se o usuário tiver redefinido a senha, mas não tiver recebido emails no endereço {{email}},
você pode copiar o link de redefinição de senha para a área de transferência e compartilhá-lo por outros meios.

Copiar o link de redefinição de senha para a área de transferência?`,
  editSurveyUserExtraPropsForUser: 'Editar propriedades extras do usuário no inventário para "{{userName}}"',
  inviteUser: 'Convidar',
  invitationExpiredClickToSendAgainTheInvitation: 'Convite expirado: clique para enviar o convite novamente',
  invitationLinkCopiedToClipboard: 'Link de convite copiado para a área de transferência',
  invitedBy: 'Convidado por',
  invitedDate: 'Data do convite',
  lastLogin: 'Último login',
  moreThan30DaysAgo: 'Há mais de 30 dias',
  notAcceptedYet: 'Convite ainda não aceito',
  passwordResetLinkCopiedToClipboard: 'Link de redefinição de senha copiado para a área de transferência',
  passwordResetLink: 'Link de redefinição de senha',
  prefs: {
    title: 'Preferências de notificação',
    notifyOnUserAccessRequest: 'Novas solicitações de acesso de usuários',
  },
  roleInCurrentSurvey: 'Função no inventário atual',
  roleInSurvey: 'Função no inventário',
  filterPlaceholder: 'Filtrar por nome ou email',
  surveyName: 'Nome do inventário',
  surveyExtraProp: {
    label: 'Propriedade extra do inventário',
    label_other: 'Propriedades extras do inventário',
  },
  surveysDraft: 'Inventários (rascunho)',
  surveysPublished: 'Inventários (publicados)',
  userRemovedFromSurveyGoToSurveysRequired: `Você foi removido deste inventário.  
Pressione Ir para inventários para abrir a lista de inventários.`,
  userRoleUpdatedRefreshRequired: `Sua função neste inventário foi atualizada.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Novo grupo',
    edit: 'Editar grupo',
    name: 'Nome',
    label: 'Rótulo',
    qualifier: 'Qualificador {{index}}',
    qualifier_other: 'Qualificadores',
    qualifierKey: 'Chave',
    qualifierValue: 'Valor',
    addQualifier: 'Adicionar qualificador',
    members: 'Membros',
    addMember: 'Adicionar membro',
    noMembers: 'Ainda não há membros',
    memberAlreadyInGroup: 'Atualmente em "{{groupName}}"',
    tabs: {
      groups: 'Grupos de usuários',
      assignments: 'Atribuição de grupos',
      report: 'Relatório de membros',
    },
    memberName: 'Nome do membro',
    memberEmail: 'Email do membro',
    memberRole: 'Função no inventário',
    memberStatus: 'Status',
    status: {
      INVITED: 'Convidado',
      ACCEPTED: 'Aceito',
      FORCE_CHANGE_PASSWORD: 'Troca de senha necessária',
    },
    unassigned: 'Não atribuído',
    confirmDelete: 'Excluir o grupo "{{name}}"? Seus membros ficarão não atribuídos. Continuar?',
    deleteConfirmed: 'O grupo "{{name}}" foi excluído',
    saveConfirmed: 'O grupo "{{name}}" foi salvo',
    confirmReassign: '{{userName}} está atualmente no grupo "{{groupName}}". Movê-lo para este grupo?',
    notFound: 'Grupo não encontrado',
    readableGroups: 'Pode ver os registros de',
    readableGroupsInfo:
      'Os membros deste grupo podem ver, exportar e baixar (também no Arena Mobile) os registros dos grupos selecionados, mas não podem editá-los',
  },
  updateUserConfirmation: 'Usuário {{name}} foi atualizado',
  userNotInvitedToAnySurvey: `Usuário não foi convidado para nenhum inventário`,
  userSurveys: 'Inventários do usuário',
  usersBackup: {
    menu: 'Backup / Restaurar',
    backup: 'Backup de usuários',
    backupTitle: 'Backup de usuários',
    backupInfo:
      'Todos os usuários serão exportados com seus papéis nos inventários e seus grupos de usuários, para que possam ser restaurados em outro servidor Arena. Os dispositivos 2FA não são exportados.',
    includePasswords: 'Incluir senhas',
    passwordsWarning:
      'O arquivo de backup conterá os hashes das senhas: guarde-o em um lugar seguro e exclua-o após o uso.',
    restore: 'Restaurar usuários',
    restoreTitle: 'Restaurar usuários a partir de um backup',
    restoreInfo: `- Os usuários são identificados pelo e-mail
- Os papéis nos inventários e os grupos de usuários são identificados pelo nome do inventário e pelo nome do grupo
- Os papéis e grupos de usuários de inventários que não existem neste servidor são ignorados
- Depois de clicar em "Restaurar usuários", você poderá escolher o que fazer com cada usuário`,
    backupFileInfo: 'Backup gerado por {{email}} em {{date}} (servidor: {{serverUrl}})',
    passwordsNotIncluded: 'As senhas não estão incluídas neste backup: os novos usuários terão que redefinir sua senha',
    allNewUsers: 'Todos os novos usuários ({{count}})',
    allExistingUsers: 'Todos os usuários existentes ({{count}})',
    userStatus: 'Status',
    userActionHeader: 'Ação',
    userNew: 'Novo',
    userExisting: 'Existente',
    userAction: {
      insert: 'Adicionar',
      skip: 'Ignorar',
      updateRoles: 'Atualizar papéis nos inventários',
      updateAll: 'Atualizar papéis nos inventários e dados',
    },
    sysAdmin: 'Admin. sist.',
    restorePassword: 'Senha',
    restorePasswordInfo:
      'Restaurar a senha armazenada no backup (apenas ao adicionar o usuário ou atualizar seus dados)',
    userActionShort: {
      insert: 'Adicionar',
      skip: 'Ignorar',
      updateRoles: 'Papéis',
      updateAll: 'Papéis + dados',
    },
    details: {
      survey: 'Inventário',
      roleInBackup: 'Papel no backup',
      currentRole: 'Papel atual',
      notFoundInThisServer: '(não encontrado neste servidor)',
      userGroup: 'Grupo de usuários',
      inBackup: 'No backup',
      currentMember: 'Membro atual',
    },
    summaryImported: 'Usuários restaurados',
    summary: {
      usersTotal: 'Usuários no backup: {{count}}',
      usersInserted: 'Novos usuários: {{count}}',
      usersUpdated: 'Usuários atualizados: {{count}}',
      usersSkipped: 'Usuários ignorados: {{count}}',
      authGroupsAdded: 'Papéis nos inventários adicionados: {{count}}',
      userGroupsAdded: 'Associações a grupos de usuários adicionadas: {{count}}',
    },
    surveysNotFound: 'Inventários não encontrados (papéis ignorados): {{names}}',
    userGroupsNotFound: 'Grupos de usuários não encontrados (associações ignoradas): {{names}}',
  },
}
